import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Separator } from '../ui/separator';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FileText, Loader2, Save } from 'lucide-react';

const ExportTab = ({ exportSettings, setExportSettings, saving, onSave }) => {
  return (
    <Card className="rounded-2xl border-[#E0D6C8]">
      <CardHeader>
        <CardTitle className="text-xl font-['Manrope'] flex items-center gap-2">
          <FileText className="w-5 h-5 text-[#5C4023]" />
          Export Document Settings
        </CardTitle>
        <CardDescription>
          Customize headers and branding for printed client Resource Lists
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <Label className="text-sm font-medium">Header Title</Label>
          <Input
            data-testid="header-title-input"
            value={exportSettings.header_title}
            onChange={(e) => setExportSettings({...exportSettings, header_title: e.target.value})}
            placeholder="617Reach Community Resources"
            className="rounded-xl mt-1.5"
          />
          <p className="text-xs text-[#888888] mt-1">Appears at the top of printed Resource Lists</p>
        </div>

        <div>
          <Label className="text-sm font-medium">Logo URL (optional)</Label>
          <Input
            data-testid="logo-url-input"
            value={exportSettings.logo_url}
            onChange={(e) => setExportSettings({...exportSettings, logo_url: e.target.value})}
            placeholder="https://example.com/logo.png"
            className="rounded-xl mt-1.5"
          />
          <p className="text-xs text-[#888888] mt-1">Link to organization logo image</p>
        </div>

        <Separator />

        <div>
          <Label className="text-sm font-medium">Resource List Footer Information</Label>
          <Textarea
            data-testid="footer-text-input"
            value={exportSettings.footer_text}
            onChange={(e) => setExportSettings({...exportSettings, footer_text: e.target.value})}
            placeholder={"Example:\nSchedule: Mon-Fri 9am-5pm\nLocations: Boston, Cambridge, Somerville\nContact: (617) 555-1234 | resourcenav.org"}
            className="rounded-xl mt-1.5"
            rows={4}
          />
          <p className="text-xs text-[#888888] mt-1">
            This text appears at the bottom of ALL Resource Lists. Use it for your schedule, contact info, 
            service area, or any important information clients should know.
          </p>
        </div>

        <div>
          <Label className="text-sm font-medium">Font Size</Label>
          <Select
            value={exportSettings.font_size}
            onValueChange={(v) => setExportSettings({...exportSettings, font_size: v})}
          >
            <SelectTrigger data-testid="font-size-select" className="rounded-xl mt-1.5">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="small">Small</SelectItem>
              <SelectItem value="medium">Medium (Default)</SelectItem>
              <SelectItem value="large">Large</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <Separator />

        <Button
          onClick={onSave}
          disabled={saving}
          data-testid="save-export-btn"
          className="w-full bg-[#5C4023] hover:bg-[#4A331C] rounded-full h-12"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
          Save Export Settings
        </Button>
      </CardContent>
    </Card>
  );
};

export default ExportTab;
